<p-dialog
  header="Edit Task Windows"
  [visible]="visible"
  (visibleChange)="visibleChange.emit($event)"
  [modal]="true"
  [style]="{ width: '500px' }"
  [closeOnEscape]="false"
  (onShow)="onShow()"
>
  <div class="ui-grid ui-grid-responsive ui-fluid">
    <div class="ui-grid-row">
      <div style="padding: 0 0 15px 5px">
        <b>NOTE: To be used when a CUSTOMER has requested a date change.</b>
      </div>
    </div>

    <div class="ui-grid-row">
      <div class="ui-g-4"><label for="pickupEarliestDateTime">Pick-up Earliest:</label></div>
      <div class="ui-g-8 md-inputfield">
        <datetime-picker
          [(ngModel)]="pickupEarliestDateTime"
          id="pickupEarliestDateTime"
          name="pickupEarliestDateTime"
          [minutesInterval]="minutesInterval"
          (ngModelChange)="alignDateTimes()"
        ></datetime-picker>
      </div>
    </div>
    <div class="ui-grid-row">
      <div class="ui-g-4"><label for="pickupLatestDateTime">Pick-up Latest:</label></div>
      <div class="ui-g-8 md-inputfield">
        <datetime-picker
          [(ngModel)]="pickupLatestDateTime"
          id="pickupLatestDateTime"
          name="pickupLatestDateTime"
          [minutesInterval]="minutesInterval"
          (ngModelChange)="alignDateTimes()"
        ></datetime-picker>
      </div>
    </div>

    <div class="ui-grid-row">
      <div class="ui-g-12"></div>
    </div>
    <div class="ui-grid-row">
      <div class="ui-g-4"><label for="dropoffEarliestDateTime">Drop-off Earliest:</label></div>
      <div class="ui-g-8 md-inputfield">
        <datetime-picker
          [(ngModel)]="dropoffEarliestDateTime"
          id="dropoffEarliestDateTime"
          name="dropoffEarliestDateTime"
          [minutesInterval]="minutesInterval"
          (ngModelChange)="alignDateTimes()"
        ></datetime-picker>
      </div>
    </div>
    <div class="ui-grid-row">
      <div class="ui-g-4"><label for="dropoffLatestDateTime">Drop-off Latest:</label></div>
      <div class="ui-g-8 md-inputfield">
        <datetime-picker
          [(ngModel)]="dropoffLatestDateTime"
          id="dropoffLatestDateTime"
          name="dropoffLatestDateTime"
          [minutesInterval]="minutesInterval"
          (ngModelChange)="alignDateTimes()"
        ></datetime-picker>
      </div>
    </div>

    <div class="ui-grid-row">
      <div class="ui-g-12"></div>
    </div>
  </div>
  <div class="ui-grid-row">
    <div class="ui-g-12"></div>
  </div>
  <p-footer style="float: right; padding-bottom: 10px">
    <button
      type="button"
      pButton
      class="ui-button-tertiary"
      label="Close"
      (click)="closeDialog()"
    ></button>
    <button
      type="button"
      class="green-btn"
      pButton
      icon="fa ui-icon-check"
      (click)="onTaskSave()"
      label="Save"
    >
      <div *ngIf="savingChecks" class="saving-checks">
        <i class="fa fa-spinner fa-spin fa-2x"></i>
      </div>
    </button>
  </p-footer>
</p-dialog>

<p-dialog
  header="Edit Task Windows"
  [(visible)]="showConfirmDates"
  [responsive]="true"
  [modal]="true"
  [blockScroll]="true"
  [style]="{ width: '500px' }"
  [closeOnEscape]="false"
  [closable]="false"
>
  <div>
    The dates/times of this Task are outside the valid range. Are you sure you want to make these
    changes ?
  </div>
  <div class="mt-2 mb-2">
    <div style="display: flex; flex-wrap: wrap; align-items: center; justify-content: center">
      <div style="flex-grow: 1; flex-basis: 100px">
        <table class="show-confirm-dates previous-dates">
          <tr>
            <td colspan="2" class="header">Old Details</td>
          </tr>
          <tr>
            <td class="right">Pick-Up Earliest:</td>
            <td class="the-date">{{ previousPickupEarly | date : 'EEE dd MMM HH:mm' }}</td>
          </tr>
          <tr>
            <td class="right">Latest:</td>
            <td class="the-date">{{ previousPickupLate | date : 'EEE dd MMM HH:mm' }}</td>
          </tr>
          <tr>
            <td colspan="2">&nbsp;</td>
          </tr>
          <tr>
            <td class="right">Drop-Off Earliest:</td>
            <td class="the-date">{{ previousDropoffEarly | date : 'EEE dd MMM HH:mm' }}</td>
          </tr>
          <tr>
            <td class="right">Latest:</td>
            <td class="the-date">{{ previousDropoffLate | date : 'EEE dd MMM HH:mm' }}</td>
          </tr>
        </table>
      </div>
      <div style="width: 50px; font-size: 30px; height: 100%; text-align: center">
        <i class="fa fa-arrow-right"></i>
      </div>
      <div style="flex-grow: 1; flex-basis: 100px">
        <table class="show-confirm-dates new-dates">
          <tr>
            <td colspan="2" class="header">New Details</td>
          </tr>
          <tr>
            <td class="right">Pick-Up Earliest:</td>
            <td class="the-date">{{ pickupEarliestDateTime | date : 'EEE dd MMM HH:mm' }}</td>
          </tr>
          <tr>
            <td class="right">Latest:</td>
            <td class="the-date">{{ pickupLatestDateTime | date : 'EEE dd MMM HH:mm' }}</td>
          </tr>
          <tr>
            <td colspan="2">&nbsp;</td>
          </tr>
          <tr>
            <td class="right">Drop-Off Earliest:</td>
            <td class="the-date">{{ dropoffEarliestDateTime | date : 'EEE dd MMM HH:mm' }}</td>
          </tr>
          <tr>
            <td class="right">Latest:</td>
            <td class="the-date">{{ dropoffLatestDateTime | date : 'EEE dd MMM HH:mm' }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>

  <div style="text-align: right; padding-top: 20px">
    <button pButton label="Cancel" class="red-btn" (click)="undoChanges()"></button>
    <button pButton label="Continue" class="green-btn" (click)="saveTaskWindows()"></button>
  </div>
</p-dialog>
